import React from 'react';
import { mockTokenomics } from '../mock';
import { Check } from 'lucide-react';

const Tokenomics = () => {
  return (
    <section id="tokenomics" className="bg-[#121212] py-20">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="text-center mb-16">
          <h2 className="text-[48px] font-semibold leading-[1.1] tracking-[-0.02em] text-white mb-4">
            PIO Token Economics
          </h2>
          <p className="text-[20px] font-medium leading-[1.5] text-[rgba(255,255,255,0.85)] max-w-2xl mx-auto">
            Sustainable tokenomics designed for long-term growth
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Token Distribution */}
          <div>
            <div className="border border-[rgba(255,255,255,0.25)] bg-black p-8 mb-6">
              <h3 className="text-[28px] font-semibold text-white mb-2">Total Supply</h3>
              <p className="text-[48px] font-bold text-[#00FFD1] mb-4">{mockTokenomics.totalSupply}</p>
              <div className="space-y-2 border-t border-[rgba(255,255,255,0.25)] pt-4">
                <div className="flex justify-between items-center">
                  <span className="text-[16px] text-[rgba(255,255,255,0.85)]">Market Cap</span>
                  <span className="text-[18px] font-semibold text-[#FFD700]">{mockTokenomics.marketCap}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-[16px] text-[rgba(255,255,255,0.85)]">PIO Value</span>
                  <span className="text-[18px] font-semibold text-[#00FFD1]">{mockTokenomics.pioValue}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-[16px] text-[rgba(255,255,255,0.85)]">Backing</span>
                  <span className="text-[16px] font-semibold text-[#FFD700]">🏆 {mockTokenomics.backing}</span>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              {mockTokenomics.distribution.map((item, index) => (
                <div
                  key={index}
                  className="border border-[rgba(255,255,255,0.25)] bg-black p-6 flex items-center justify-between hover:border-[#00FFD1] transition-all duration-400"
                >
                  <div className="flex items-center gap-4">
                    <div
                      className="w-12 h-12 flex items-center justify-center"
                      style={{ backgroundColor: item.color }}
                    >
                      <span className="text-black font-bold">{item.percentage}%</span>
                    </div>
                    <span className="text-[18px] font-medium text-white">
                      {item.category}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Token Utilities */}
          <div>
            <div className="border border-[rgba(255,255,255,0.25)] bg-black p-8">
              <h3 className="text-[32px] font-semibold leading-[1.2] text-white mb-8">
                Token Utilities
              </h3>
              <div className="space-y-6">
                {mockTokenomics.utilities.map((utility, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-[#00FFD1] flex items-center justify-center flex-shrink-0">
                      <Check className="w-5 h-5 text-black" />
                    </div>
                    <p className="text-[18px] font-normal leading-[1.5] text-[rgba(255,255,255,0.85)]">
                      {utility}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-10 pt-8 border-t border-[rgba(255,255,255,0.25)]">
                <p className="text-[16px] text-[#4D4D4D] leading-[1.4]">
                  Token contract audited by leading security firms. Liquidity locked for 2 years.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tokenomics;
